import { render, staticRenderFns } from "./ContentSideBySide.vue?vue&type=template&id=8e8914d6&scoped=true&"
import script from "./ContentSideBySide.vue?vue&type=script&lang=js&"
export * from "./ContentSideBySide.vue?vue&type=script&lang=js&"
import style0 from "./ContentSideBySide.vue?vue&type=style&index=0&id=8e8914d6&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8e8914d6",
  null
  
)

export default component.exports